import { Pipe, PipeTransform } from '@angular/core';
import { UserRoles } from '@shared/types/api-types';

@Pipe({
  name: 'userRole',
})
export class UserRolePipe implements PipeTransform {
  transform(role: UserRoles): string {
    switch (role) {
      case 'ADMIN_COMMON':
        return $localize`Администратор`;
      case 'ADMIN_RESPONSIBLE':
        return $localize`Ответственный администратор`;
      case 'PDU_PERFORMER':
        return $localize`Исполнитель`;
      default:
        return '';
    }
  }
}
